import { Layout } from 'antd';
import React, { useState } from 'react';

import { useMediaType } from 'technical/media/hooks';
import { MobileHeader } from 'ui/mobile-header';
import NavBar from 'ui/navBar';

import styles from './index.module.scss';

const { Content, Footer } = Layout;

interface Props {
  children?: React.ReactNode;
  img?: { src: string; alt: string };
  footer?: React.ReactNode;
  isConnected: boolean;
  title: string;
  constructionSiteChangeEnabled?: boolean;
}

function Page({
  children = null,
  footer = null,
  img,
  isConnected,
  title,
  constructionSiteChangeEnabled = true,
}: Props) {
  const { isMobile, isTablet } = useMediaType();

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Layout className={styles.layout}>
      {isMobile || isTablet ? (
        <MobileHeader
          title={title}
          isConnected={isConnected}
          menuState={{ open: menuOpen, setOpen: setMenuOpen }}
          constructionSiteChangeEnabled={constructionSiteChangeEnabled}
        />
      ) : (
        <NavBar
          isConnected={isConnected}
          title={title}
          menuState={{ open: menuOpen, setOpen: setMenuOpen }}
          constructionSiteChangeEnabled={constructionSiteChangeEnabled}
        />
      )}
      {img ? <img src={img.src} alt={img.alt} /> : null}
      <Content className={styles.content}>{children}</Content>
      {footer ? <Footer className={styles.footer}>{footer}</Footer> : null}
    </Layout>
  );
}

export default Page;
